import { useEffect } from 'react'
import { useDocumentState } from '@/state'
import { useShallow } from 'zustand/react/shallow'
import { useBulkDeleteTemplateAttributes } from '@/services/queries/template_attributes'

export const useEnabledTemplateAttributesMultiSelect = () => {
  const { mutate: bulkDeleteTemplateAttributes, isPending: isDeleting } =
    useBulkDeleteTemplateAttributes()

  const getDocumentState = useDocumentState(
    useShallow((state) => state.getState),
  )

  useEffect(() => {
    const handleDelete = (e) => {
      if (e.key === 'Delete' || e.key === 'Backspace') {
        if (!isDeleting) {
          const { currentPageInView, bulkSelectedTemplateAttributes } =
            getDocumentState()

          if (currentPageInView && bulkSelectedTemplateAttributes.length > 0) {
            bulkDeleteTemplateAttributes({
              documentPageId: currentPageInView,
              templateAttributes: bulkSelectedTemplateAttributes,
            })
          }
        }
      }
    }

    document.addEventListener('keyup', handleDelete)

    return () => {
      document.removeEventListener('keyup', handleDelete)
    }
  }, [])
}
